import Vue from 'vue'

// 定义全局过滤器 formatDate
Vue.filter('formatDate', function(value) {
    if (!value) return '';
    
    const date = new Date(value);
  
    // 获取年份、月份、日期
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，所以要加1
    const day = date.getDate().toString().padStart(2, '0');
  
    return `${year}-${month}-${day}`;
});


Vue.filter('formatDate2', function(value) {
    if (!value) return ''
    
    // 创建一个新的日期对象，参数为时间戳（单位是毫秒）
    let date = new Date(value * 1000)
    
    let year = date.getFullYear()
    let month = (date.getMonth() + 1).toString().padStart(2, '0')
    let day = date.getDate().toString().padStart(2, '0')

    let hours = date.getHours().toString().padStart(2, '0')
    let minutes = date.getMinutes().toString().padStart(2, '0')
    let seconds = date.getSeconds().toString().padStart(2, '0')

    // 返回格式化后的日期字符串
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
})


Vue.filter('stripHtmlTags', function(value) {
    if (!value || typeof value !== 'string') {
        return '';
    }
    return value.replace(/<[^>]+>/g, '');
})